export default "/images/6cbeb8bba7ba9701384f004b7a463963.png";